export default "__VITE_ASSET__D5vXQIWl__"